import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from './action-sheet';
import { captureException } from '@/utils/sentry';
import { openPDF, openWebBrowserURL } from '@/utils/navigation';
import { partnerSupplier } from '@/utils/environment';
import { useToasts } from '@/contexts/toast-context';

export interface RedirectActionSheetProps {
  isRedirectSheetOpen: boolean;
  redirectURL: string | null;
  setIsRedirectSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RedirectActionSheet: React.FC<RedirectActionSheetProps> = ({
  isRedirectSheetOpen,
  redirectURL,
  setIsRedirectSheetOpen,
}) => {
  const { showErrorToast } = useToasts();

  const handleAction = async (idx: number) => {
    const isConfirmAction = idx === 0;
    Analytics.track(
      `redirect_sheet.${isConfirmAction ? 'confirm' : 'cancel'}_button.press`,
    );

    if (isConfirmAction && redirectURL) {
      try {
        if (redirectURL.endsWith('.pdf')) {
          await openPDF(redirectURL);
        } else {
          await openWebBrowserURL(redirectURL);
        }
      } catch (error) {
        captureException(error);
        showErrorToast();
      }
    }
    setIsRedirectSheetOpen(false);
  };

  return (
    <ActionSheet
      actions={[
        i18n.t('redirect_sheet.confirm'),
        i18n.t('redirect_sheet.cancel'),
      ]}
      isVisible={isRedirectSheetOpen}
      message={i18n.t('redirect_sheet.message')}
      onAction={(_name, idx) => handleAction(idx)}
      onClose={() => setIsRedirectSheetOpen(false)}
      title={i18n.t('redirect_sheet.title', {
        appName: partnerSupplier.fullName,
      })}
    />
  );
};
